import { render, staticRenderFns } from "./SGPBoxComponent.vue?vue&type=template&id=0fd07362&scoped=true"
import script from "./SGPBoxComponent.vue?vue&type=script&lang=js"
export * from "./SGPBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPBoxComponent.vue?vue&type=style&index=0&id=0fd07362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd07362",
  null
  
)

export default component.exports